export default "__VITE_ASSET__CId7Fxg3__"